<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-card-text>
        <!-- primary -->
        <b-alert variant="primary" show>
          <h4 class="alert-heading">
            Keterangan
          </h4>
          <div class="alert-body">
            <div>
              Lengkapi form dibawah ini, form akan tampil sesuai dengan Jenis Konsultasi yang
              dipilih.
            </div>
          </div>
        </b-alert>
      </b-card-text>
      <b-row v-if="jenisPertanyaan.data">
        <b-col v-for="data in jenisPertanyaan.data.data" :key="data.pertanyaan_id" md="6">
          <b-form-group :label="data.judul">
            <div class="demo-inline-spacing" v-if="data.tipe_pertanyaan === 'Radio'">
              <span v-for="jawaban in data.jawaban" :key="jawaban.id" md="4">
                <b-form-radio
                  :name="data.id"
                  :value="jawaban.id"
                  v-model="data.answer"
                  v-if="jawaban.id"
                >
                  {{ jawaban.label }}
                </b-form-radio>
              </span>
            </div>
            <div v-if="data.tipe_pertanyaan === 'Input'" col="6">
              <b-form-input v-model="data.answer" :name="'pertanyaan{$data.id}'" />
            </div>
            <div v-if="data.tipe_pertanyaan === 'Date'" col="6">
              <flat-pickr
                v-model="data.answer"
                class="form-control"
                :name="'pertanyaan{$data.id}'"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <!-- <b-row
        v-if="$can('proses', 'tiket')"
      >
        <b-col
          md="6"
        >
          <b-form-group
            label="Tanggal Mulai"
          >
            <flat-pickr
            disabled
              v-model="rows.tanggal_mulai"
              class="form-control"
              style="background-color :#d5d5d599"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="6"
        >
          <b-form-group
            label="Tanggal Akhir"
          >
            <flat-pickr
              v-model="rows.tanggal_akhir"
              class="form-control"
              disabled
              style="background-color :#d5d5d599"
            />
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col md="6">
          <b-form-group
            label-for="statusTiketList"
            label="Status Konsultasi"
            v-if="$can('proses', 'tiket')"
          >
            <v-select
              v-model="rows.status_tiket_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusTiketOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="jenis_tiket"
              disabled
            />
          </b-form-group>
          <b-form-group label-for="statusTiketList" label="Status Konsultasi" v-else>
            <v-select
              v-model="rows.status_tiket_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusTiketOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="jenis_tiket"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="
          $can('supervisor', 'tiket') &&
            rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f2'
        "
      >
        <b-col md="6">
          <b-form-group label="Tanggal Akhir Perubahan">
            <flat-pickr v-model="rows.tanggal_akhir_perubahan" class="form-control" />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="rows.tanggal_akhir_perubahan !== rows.tanggal_akhir">
          <b-form-group label="Alasan Penundaan" label-for="alasanpenundaan-area">
            <b-form-textarea
              id="alasanpenundaan-area"
              v-model="rows.alasan_penundaan"
              rows="4"
              placeholder="Alasan Penundaan disini..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" v-if="rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f5'">
          <b-form-group label="Solusi" label-for="solusi-area">
            <b-form-textarea
              disabled
              id="solusi-area"
              v-model="rows.solusi"
              rows="4"
              placeholder="Solusi disini..."
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="rows.alasan_assign !== null">
          <b-form-group label="Alasan Proses Oper Konsultasi" label-for="alasan_proses-oper-tiket">
            <b-form-textarea
              id="alasan_proses-oper-tiket"
              v-model="rows.alasan_assign"
              rows="4"
              placeholder="Alasan Proses Oper Konsultasi..."
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f3'">
          <b-form-group label="Alasan Tidak di Proses" label-for="alasan_tidak_diproses-area">
            <b-form-textarea
              disabled
              id="alasan_tidak_diproses-area"
              v-model="rows.alasan_tidak_diproses"
              rows="4"
              placeholder="Alasan Tidak di Proses disini..."
              readonly
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="rows.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f2'">
          <b-form-group label="Alasan Penundaan" label-for="alasan_tunda-area">
            <b-form-textarea
              disabled
              id="alasan_penundaan_helpdesk-area"
              v-model="rows.alasan_penundaan"
              rows="4"
              placeholder="Alasan Penundaan disini..."
            />
          </b-form-group>
        </b-col>
        <!-- <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            @click="simpan"
            v-if="$can('proses', 'tiket') && canUpdate(rows) && rows.status_tiket.nama !== 'Selesai'"
          >
            Proses
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            @click="simpan"
            v-if="!$can('proses', 'tiket') && canUpdate(rows)"
          >
            Kirim Tiket
          </b-button>
        </b-col> -->
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormTextarea,
  BFormRadio,
  BAlert,
  BCardText,
} from 'bootstrap-vue'
import { getPertanyaan, getStatusTiket, getStatusTiketDetail } from '@/connection-api/master'
import { getTiket } from '@/connection-api/tiket'
import store from '@/store'
import storeModule from '@/connection-api/user/storeModule'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    // BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BFormRadio,
    BCard,
    BFormTextarea,
    BAlert,
    BCardText,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  props: {
    informationData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: {},
      profileFile: null,
      jenisPertanyaan: {},
      userData: JSON.parse(localStorage.getItem('userData')),
      userId: null,
      rows: {},
      statusTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Status --' }],
      },
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      const responseStatus = await getStatusTiketDetail()
      this.mappingSelectOption(responseStatus.data, this.statusTiketOptions.options)
      const response = await getTiket(this.$route.params.id)
      this.rows = response.data.data
      this.jenisPertanyaan = await getPertanyaan(this.$route.params.id)
    }
  },
  methods: {
    simpan() {
      this.optionsLocal = this.rows
      this.optionsLocal.id = this.$route.params.id
      this.optionsLocal.jenisPertanyaan = this.jenisPertanyaan.data.data
      this.$emit('clicked', this.optionsLocal)
    },
    resetForm() {
      this.localOptions = JSON.parse(JSON.stringify(this.informationData))
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    canUpdate(data) {
      if (this.$can('manage', 'all')) {
        return true
      }
      if (data.is_draft === 'e2281ff8-2558-11ee-acb1-3497f616f0' && this.$can('update', 'tiket')) {
        return false
      }
      if (data.user_id === this.userData.id && this.$can('update', 'tiket')) {
        return true
      }
      // if (data.user_tiket_all.length === 0 && this.$can('update', 'tiket')) {
      //   return true
      // }
      // if (data.user_tiket && data.user_tiket[0] && this.$can('update', 'tiket') && data.user_tiket[0].status_approval_id === 2) {
      //   return true
      // }
      return false
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
